// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__ptTbM","content":"RecentSearches_content__2gx6y"};